import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { t } from '../i18n';
import About from './About';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const savedLang = localStorage.getItem("language");

  if (!savedLang) {
      const browserLang =
          navigator.language.split("-")[0];

      localStorage.setItem("language", browserLang);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(t('invalidCredentials'));
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '400px', margin: '50px auto' }}>
        <h2>{t('login')}</h2>
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('username')}</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">{t('login')}</button>
        </form>
        <p style={{ marginTop: '12px' }}>
          <a href="/forgot-password">{t('forgotPasswordQuestion')}</a>
        </p>
        <p style={{ marginTop: '8px' }}>
          {t('dontHaveAccount')} <a href="/register">{t('registerHere')}</a>
        </p>
      </div>
      <About />
    </div>
  );
};

export default Login;
